// src/utils/translations.js

export const translations = {
  en: {
    comm_cta_desc: "Plant your first tree today and join the leaderboard.",
    comm_cta_title: "Your name could be on this list",
    comm_loading: "Loading community…",
    comm_empty: "No trees have been planted yet. Be the first!",
    comm_planted_for: "Planted for",
    comm_no_location: "Location coming soon",
    comm_view_map: "View on map",
    comm_recent_sub: "The latest trees our team has planted for members",
    comm_recent_title: "Recently planted",
    comm_stat_regions: "Regions",
    comm_stat_planted: "Trees planted",
    comm_stat_members: "Members",
    home_price_from: "from",
    home_feat_all: "See all trees",
    home_feat_title: "Start with one of these",
    home_feat_label: "Popular trees",
    home_how_3_d: "Find your tree on the live map and see it in your profile.",
    home_how_3_t: "Follow it",
    home_how_2_d: "Our team plants your tree in the ground for you. No shovel needed.",
    home_how_2_t: "We plant it",
    home_how_1_d: "Pick from {n} local tree species in our shop. Prices start at {price} UZS.",
    home_how_1_t: "Choose a sapling",
    home_how_title: "Your own tree in three simple steps",
    home_how_label: "How it works",
    auth_step_account: "Account",
    auth_step_contact: "Contact details",
    auth_btn_next: "Continue",
    auth_btn_back: "Back",
    auth_ok_registered: "Your account is ready! Sign in to continue.",
    auth_err_session: "You were signed in, but your browser blocked the login cookie. Please try again or use another browser.",
    comm_btn_plant: "Plant a tree",
    auth_err_network: "Can't reach the server. Check your connection and try again.",
    auth_err_register: "Registration failed. Please check your details and try again.",
    auth_err_login: "Wrong username or password. Please try again.",
    map_trees_no_location: "trees are still waiting for their GPS location",
    shop_filters_title: "Filters",
    main_stat_species: "Tree species",

    "map_advanced_filters": "Advanced Filters",
    "map_filter_year": "Filter by Year",
    "map_all_years": "All Years",
    "map_show_my_trees": "Show Only My Trees",
    "map_showing": "Showing",
    "map_search_species": "Search Tree Species",
    "map_search_placeholder": "Type tree name...",
    "map_no_species_found": "No species found",

    // English (en)
    shop_cat_decorative: "Decorative Trees",
    shop_cat_fruit_trees: "Fruit Trees",
    shop_cat_flowers: "Decorative Flowers",
    shop_cat_bushes: "Bushes",
    shop_events: "Events", // for "Events" label in user stats

    // Navbar
    nav_home: "Home",
    nav_shop: "Shop",
    nav_map: "Map",
    nav_community: "Community",
    nav_signin: "Sign In",
    nav_register: "Register",
    nav_profile: "Profile",
    nav_logout: "Logout",

    // Footer
    foot_about: "About Novda",
    foot_desc: "Making tree planting simple, transparent, and scalable across Uzbekistan.",
    foot_links: "Quick Links",
    foot_services: "Services",
    foot_contact: "Contact",
    foot_rights: "Novda. All rights reserved. Making the world greener, one tree at a time.",
    foot_privacy: "Privacy Policy",
    foot_svc_plant: "Tree Planting",
    foot_svc_corp: "Corporate Programs",
    foot_svc_track: "Track Your Trees",
    foot_svc_gift: "Gift a Tree",

    // Auth
    auth_join_title: "Join the",
    auth_join_highlight: "Green Revolution",
    auth_join_desc: "Access your environmental dashboard to track your trees, view community impact, and manage your contributions.",
    auth_feat_track_title: "Plant & Track Trees",
    auth_feat_track_desc: "Monitor your trees with GPS tracking",
    auth_feat_comm_title: "Community Access",
    auth_feat_comm_desc: "Connect with fellow tree planters",
    auth_feat_impact_title: "Impact Metrics",
    auth_feat_impact_desc: "Real-time CO₂ absorption stats",
    auth_tab_register: "Register",
    auth_tab_login: "Sign In",
    auth_label_fname: "First Name",
    auth_label_lname: "Last Name",
    auth_label_username: "Username",
    auth_label_phone: "Phone Number",
    auth_label_email: "Email Address",
    auth_label_dob: "Birth Date",
    auth_label_region: "Region",
    auth_label_pass: "Password",
    auth_ph_phone: "+998-__-___-__-__",
    auth_select_region: "Select a region",
    auth_btn_create: "Create Account",
    auth_btn_login: "Log In",
    auth_region_qoraqalpaq: "Republic of Karakalpakstan",
    auth_region_andijan: "Andijan Region",
    auth_region_bukhara: "Bukhara Region",
    auth_region_fergana: "Fergana Region",
    auth_region_jizzakh: "Jizzakh Region",
    auth_region_khorezm: "Khorezm Region",
    auth_region_namangan: "Namangan Region",
    auth_region_navoiy: "Navoiy Region",
    auth_region_kashkadarya: "Kashkadarya Region",
    auth_region_samarkand: "Samarkand Region",
    auth_region_sirdaryo: "Sirdaryo Region",
    auth_region_surkhandarya: "Surkhandarya Region",
    auth_region_tashkent_reg: "Tashkent Region",
    auth_region_tashkent_city: "Tashkent City",

    // Main Page - Hero
    main_hero_badge: "Plant Trees, Make Impact",
    main_hero_title_1: "Plant Trees,",
    main_hero_title_2: "Save the Planet",
    main_hero_desc: "Choose a sapling online, our team plants it for you, and you follow your tree on the map.",
    main_btn_start: "Start Planting Now",
    main_btn_watch: "Watch Video",
    main_stat_trees: "Trees Planted",
    main_stat_members: "Active Members",
    main_stat_regions: "Regions",
    main_float_co2_label: "A grown tree per year",
    main_float_co2_val: "≈22 kg CO₂",
    main_float_comm_label: "Every tree",
    main_float_comm_val: "Tracked on the map",
    // Main Page - About (The 6 check items)
    main_about_label: "ABOUT NOVDA",
    main_about_title: "Our Mission",
    main_about_subtitle: "A digital environmental platform making tree planting simple, transparent, and scalable.",
    main_check_1: "Real, verifiable trees planted by professionals",
    main_check_2: "Track every tree on our interactive map",
    main_check_3: "Get regular updates on tree health & growth",
    main_check_4: "Transparent pricing with no hidden fees",
    main_check_5: "Join a growing community of nature lovers",
    main_check_6: "Make a measurable environmental impact",

    // Main Page - Why Us (The 4 cards)
    main_why_label: "WHY CHOOSE US",
    main_why_title: "What Makes Us Different",
    main_why_subtitle: "Discover the advantages of choosing Novda for your environmental impact.",
    main_card_real_title: "Real Tree Planting",
    main_card_real_desc: "Every tree is planted by expert teams in optimal conditions and verified with GPS coordinates.",
    main_card_trans_title: "Full Transparency",
    main_card_trans_desc: "Track your trees on our interactive map and receive regular photo updates showing their growth.",
    main_card_comm_title: "Community Impact",
    main_card_comm_desc: "Join members across Uzbekistan who are creating real environmental change.",
    main_card_res_title: "Measurable Results",
    main_card_res_desc: "See the tangible impact of your contribution with detailed CO₂ absorption metrics.",

    // Main Page - Stats
    main_impact_title: "Our Impact So Far",
    main_impact_subtitle: "Real numbers from real environmental action",

    // Main Page - Process (The 4 steps at bottom)
    main_process_label: "HOW IT WORKS",
    main_process_title: "Simple Steps to Make Impact",
    main_process_subtitle: "Start your environmental journey in just four easy steps",
    main_step_browse: "Browse Trees",
    main_step_browse_desc: "Explore our collection of native tree species and learn about their environmental benefits for Uzbekistan's climate.",
    main_step_select: "Select & Buy",
    main_step_select_desc: "Choose your tree and complete the secure payment process in just a few clicks with transparent pricing.",
    main_step_plant: "We Plant It",
    main_step_plant_desc: "Our expert team professionally plants your tree in optimal conditions verified with GPS coordinates.",
    main_step_track: "Track & Monitor",
    main_step_track_desc: "Receive regular updates and watch your tree grow on our interactive map with photo updates and metrics.",

    // Shop Page
    shop_hero_badge: "Plant Trees, Save Planet",
    shop_hero_title: "Choose Your",
    shop_hero_highlight: "Tree",
    shop_hero_desc: "Browse our carefully curated selection of native and adaptive tree species perfect for Uzbekistan's climate.",
    shop_search_placeholder: "Search by tree name or species...",
    shop_filter_cat: "Category:",
    shop_filter_price: "Price:",
    shop_sort_label: "Sort by:",
    shop_cat_all: "All",
    shop_cat_tree: "Decorative Trees",
    shop_cat_fruit: "Fruit Trees",
    shop_price_all: "All Prices",
    shop_price_under_80: "Under 80K",
    shop_price_80_110: "80K - 110K",
    shop_price_over_110: "Over 110K",
    shop_sort_name_asc: "Name (A-Z)",
    shop_sort_name_desc: "Name (Z-A)",
    shop_sort_price_asc: "Price (Low to High)",
    shop_sort_price_desc: "Price (High to Low)",
    shop_btn_add: "Add to Cart",
    shop_btn_added: "✓ Added",
    shop_btn_details: "Details",
    shop_empty_title: "No trees found",
    shop_empty_desc: "Try adjusting your filters or search query",
    shop_clear_filters: "Clear All Filters",
    shop_loading: "Loading products...",
    shop_error: "Failed to load products. Please make sure backend is running.",
    shop_found: "trees found",

    // Product Detail
    prod_not_found: "Product not found",
    prod_back: "Back to Shop",
    prod_add_cart: "Add to Cart",
    prod_desc_fallback: "No description available.",
    prod_loading: "Loading product...",
    prod_not_found_desc: "The tree you're looking for doesn't exist",
    prod_price: "Price",
    prod_qty: "Quantity",
    prod_info_delivery: "Free Delivery",
    prod_info_delivery_desc: "On orders over 500,000 UZS",
    prod_info_quality: "Quality Guarantee",
    prod_info_quality_desc: "100% healthy plants",
    prod_info_support: "24/7 Support",
    prod_info_support_desc: "Expert gardening advice",

    // Cart
    cart_title: "Shopping Cart",
    cart_empty_title: "Your cart is empty",
    cart_empty_text: "Start planting trees for a greener future!",
    cart_btn_browse: "Browse Trees",
    cart_banner_text: "You can change the size and quantity for each tree below",
    cart_shipping: "Free planting service on all orders!",
    cart_customize: "Customize Your Tree",

    cart_qty: "Quantity",
    cart_item_total: "Item Total:",
    cart_continue: "Continue Shopping",
    cart_summary_title: "Order Summary",
    cart_subtotal: "Subtotal",
    cart_discount: "Special Discount: ",
    cart_service: "Planting Service",
    cart_free: "FREE",
    cart_total: "Total",
    cart_checkout: "Proceed to Checkout",
    cart_secure: "Secure Checkout · SSL Encrypted",
    cart_item_single: "item",
    cart_item_plural: "items",
    cart_you_save: "You save",
    cart_info_planting: "Free Planting Service",
    cart_info_planting_desc: "We plant your tree professionally",
    cart_info_quality: "Quality Guarantee",
    cart_info_quality_desc: "100% healthy trees or replacement",
    cart_info_support: "24/7 Support",
    cart_info_support_desc: "We're here to help you",

    // Checkout
    check_title: "Checkout",
    check_desc: "Complete your tree planting order",
    check_info_title: "Planting Information",
    check_label_name: "Full Name",
    check_ph_name: "Enter your full name",
    check_note_cert: "For your digital certificate",
    check_label_phone: "Phone Number",
    check_label_region: "Planting Region",
    check_select_region: "Select a region",
    check_dedication_title: "Tree Dedications",
    check_dedication_desc: "Each tree will appear on our interactive map. Add personal messages for each one.",
    check_mode_same: "Same dedication for all trees",
    check_mode_indiv: "Individual dedications",
    check_msg_label: "Dedication Message (Optional)",
    check_msg_ph: "In memory of... / For my family...",
    check_payment_title: "Payment Method",
    check_btn_pay: "Complete Order",
    check_processing: "Processing Payment...",
    check_err_name: "Full name is required",
    check_err_phone: "Phone number is required",
    check_err_region: "Please select a region",
    check_err_payment: "Please select payment method",
    check_tree_num: "Tree",
    check_trees_qty: "Quantity of Trees",
    check_title_review: "Review Order",
    check_subtitle_review: "Please review your order details before proceeding to payment",
    check_items_title: "Order Items",

    check_item_qty: "Qty",
    check_off: "OFF",
    check_btn_back_cart: "Back to Cart",
    check_btn_continue: "Proceed to Payment",
    check_secure: "Secure Checkout",
    check_ssl: "SSL Encrypted",
    check_info_note: "To update your information, please visit your profile page",
    check_total_trees: "Total Trees",

    // Payment Page
    pay_title: "Payment",
    pay_subtitle: "Select your payment method to complete the order",
    pay_order_summary: "Order Summary",
    pay_subtotal: "Subtotal",
    pay_discount: "Discount",
    pay_total_amount: "Total Amount",
    pay_back: "Back",
    pay_processing: "Processing...",
    pay_complete: "Complete Order",
    pay_your_order: "Your Order",
    pay_total_trees: "Total Trees",
    pay_total: "Total",
    pay_secure: "Secure Payment",
    pay_ssl: "SSL Encrypted",
    pay_loading: "Loading...",

    // Order Confirmation
    order_confirmed: "Order Confirmed!",
    order_thank_you: "Thank you for contributing to a greener future",
    order_id: "Order ID",
    order_date: "Date",
    order_impact_text: "Environmental Impact: Your order will help absorb approximately",
    order_btn_home: "Back to Home",

    // Profile
    prof_edit: "Edit",
    prof_trees: "Trees",
    prof_badges: "Badges",
    prof_interests: "Interests:",
    prof_location: "Location",
    prof_email: "Email",
    prof_phone: "Phone",
    prof_joined: "Joined",
    prof_my_trees: "My Trees",
    prof_view_map: "View on Map",
    prof_share: "Share Tree",
    prof_recent_activity: "Recent Activity",
    prof_impact: "Environmental Impact",
    prof_roadmap: "Achievement Roadmap",
    prof_progress: "Your Progress",
    prof_badge_eco: "Eco Warrior",
    prof_badge_gold: "Gold Member",
    prof_badge_ver: "Verified",
    prof_co2_seq: "Total CO₂ Sequestered",
    prof_oxy_prod: "Oxygen Produced (Est.)",
    prof_wild_hab: "Wildlife Habitat Created",
    prof_land_green: "Land Area Greened",
    prof_modal_title: "Edit Profile",
    prof_label_name: "Full Name",
    prof_label_bio: "Bio",
    prof_label_phone: "Phone Number",
    prof_label_region: "Region",
    prof_label_email: "Email",
    prof_btn_save: "Save Changes",
    prof_btn_cancel: "Cancel",
    prof_btn_saving: "Saving...",
    prof_planted_on: "Planted On",

    // Orders
    orders_title: "My Orders",
    orders_subtitle: "Track your tree orders and planting progress",
    orders_loading: "Loading your orders...",
    orders_total: "Total Orders",
    orders_trees_ordered: "Trees Ordered",
    orders_active: "Active",
    orders_completed: "Completed",
    orders_filter_all: "All Orders",
    orders_filter_active: "Active",
    orders_filter_completed: "Completed",
    orders_empty_title: "No orders yet",
    orders_empty_filter: "No orders match this filter",
    orders_empty_desc: "Visit the shop to order your first trees!",
    orders_go_shop: "Go to Shop",
    orders_order_id: "Order",
    orders_quantity: "Qty",

    orders_status_ordered: "Ordered",
    orders_status_processing: "Processing",
    orders_status_planted: "Planted",
    orders_step_ordered: "Ordered",
    orders_step_processing: "Processing",
    orders_step_planted: "Planted",

    // Map
    map_filter_all: "All",
    map_welcome_title: "Novda Map",
    map_welcome_desc: "Welcome to the digital forest. This platform tracks real trees planted to improve our city's ecosystem.",
    map_guide_explore: "How to Explore",
    map_stat_mapped: "Trees Mapped",
    map_stat_co2: "kg CO₂ Removed",
    map_adopt_btn: "Adopt Similar Tree",
    map_swipe: "Swipe for photos",
    map_urban_contrib: "Urban Contribution",
    map_health_well: "Health & Wellbeing",
    map_total_co2: "Total CO₂ Removed",
    map_tree_age: "Tree Age",
    map_owner: "Owner",
    map_region: "Region",
    map_superpower: "City Impact",
    map_impact_title: "Project Impact",
    map_active_zones: "Active Zones",
    map_survival_rate: "Survival Rate",

    // Community
    comm_hero_title: "Our Growing",
    comm_hero_highlight: "Community",
    comm_hero_desc: "Join volunteers, environmentalists, and nature lovers working together to make Uzbekistan greener.",
    comm_btn_join: "Join the Community",
    comm_btn_leaderboard: "View Leaderboard",
    comm_champions: "Community Champions",
    comm_subtitle_champions: "Meet the most active members making a difference today",
    comm_leaderboard_title: "Top planters",
    comm_subtitle_leaderboard: "Members ranked by the number of trees planted for them",
    comm_voices: "Community Voices",
    comm_subtitle_voices: "What our volunteers say about their planting journey",
    comm_rank: "Rank",
    comm_user: "User",
    comm_region: "Region",
    comm_trees_planted: "Trees Planted",
    comm_impact_co2: "Impact (CO₂)",
    comm_planting_journey: "Our Planting Journey",
    comm_subtitle_journey: "Moments from our volunteering events and team work",

    // Community - Roles
    comm_role_eco_warrior: "Eco Warrior",
    comm_role_community_lead: "Community Lead",
    comm_role_volunteer: "Volunteer",
    comm_role_ambassador: "Ambassador",

    // Community - Stat labels
    comm_stat_trees: "Trees",
    comm_stat_events: "Events",

    // Community - Testimonials
    comm_quote_1: "Planting my first tree with Novda was an emotional moment. Knowing I can track its growth makes it even more special. It's not just a donation; it's a legacy.",
    comm_quote_2: "The community events are amazing. I've met so many like-minded people who care about our environment. The transparency of this platform is unmatched.",
    comm_quote_3: "I gifted trees to my employees for New Year. They loved the idea of having their own trees on the map. Best corporate gift ever! Really enjoyed the process.",
    comm_quote_4: "It's incredible to see how many people are joining this movement. The map feature is addictive - I check it every day to see new trees popping up!",
    comm_author_role_business: "Business Owner",
    comm_author_role_student: "Student",

    // Filters
    filter_all: "All",
    filter_fruit: "Fruit Trees",
    filter_evergreen: "Evergreen",
    filter_shade: "Shade",
    filter_decorative: "Decorative Trees",
    filter_tree: "Tree",

    // Additional Map Keys
    map_cat_all: "All Trees",
    map_cat_fruit: "Fruit Trees",
    map_cat_decorative: "Decorative Trees",
    map_cat_flowers: "Flowers",
    map_cat_bushes: "Bushes",
    map_filter_btn: "Filters",
    map_year_label: "Year",
    map_year_all: "All Years",
    map_search_label: "Search Tree",
    map_search_ph: "Type tree name...",
    map_my_trees: "Show only my trees",
    map_showing: "Showing",
    map_clear: "Clear All",
    map_welcome_explore: "How to explore",
    map_step_filter: "Use filters to find specific trees",
    map_step_click: "Click markers to see tree details",
    map_step_photos: "View photos of planted trees",
    map_impact_header: "Impact",
    map_stat_trees_short: "Trees",
    map_stat_co2_short: "kg CO₂",
    map_stat_regions: "Regions",
    map_stat_years_active: "Years Active",
    main_stat_co2: "CO₂ Absorbed",
    map_swipe_short: "Swipe",
    map_desc_title: "Description",
    map_health_title: "Health Benefits",
    map_meta_co2: "CO₂ Absorbed",
    map_meta_age: "Age",
    map_meta_owner: "Owner",
    map_meta_planted_by: "Planted By",
    map_meta_planted_on: "Planted on",
    map_benefit_air: "Clean Air",
    map_benefit_shade: "Shade",
    map_benefit_mental: "Mental Health",
  },

  ru: {
    comm_cta_desc: "Посадите своё первое дерево сегодня и попадите в рейтинг.",
    comm_cta_title: "Ваше имя может быть в этом списке",
    comm_loading: "Загрузка сообщества…",
    comm_empty: "Пока не посажено ни одного дерева. Станьте первым!",
    comm_planted_for: "Посажено для",
    comm_no_location: "Место скоро появится",
    comm_view_map: "На карте",
    comm_recent_sub: "Последние деревья, которые наша команда посадила для участников",
    comm_recent_title: "Недавно посажены",
    comm_stat_regions: "Регионов",
    comm_stat_planted: "Посажено деревьев",
    comm_stat_members: "Участников",
    home_price_from: "от",
    home_feat_all: "Все деревья",
    home_feat_title: "Начните с одного из них",
    home_feat_label: "Популярные деревья",
    home_how_3_d: "Найдите своё дерево на карте и в профиле.",
    home_how_3_t: "Следите за ним",
    home_how_2_d: "Наша команда посадит ваше дерево за вас. Лопата не нужна.",
    home_how_2_t: "Мы его посадим",
    home_how_1_d: "В магазине {n} местных видов деревьев. Цены от {price} UZS.",
    home_how_1_t: "Выберите саженец",
    home_how_title: "Своё дерево в три шага",
    home_how_label: "Как это работает",
    auth_step_account: "Аккаунт",
    auth_step_contact: "Контакты",
    auth_btn_next: "Продолжить",
    auth_btn_back: "Назад",
    auth_ok_registered: "Аккаунт создан! Войдите, чтобы продолжить.",
    auth_err_session: "Вход выполнен, но браузер заблокировал cookie входа. Попробуйте снова или используйте другой браузер.",
    comm_btn_plant: "Посадить дерево",
    auth_err_network: "Нет связи с сервером. Проверьте подключение и попробуйте снова.",
    auth_err_register: "Не удалось зарегистрироваться. Проверьте данные и попробуйте снова.",
    auth_err_login: "Неверное имя пользователя или пароль. Попробуйте снова.",
    map_trees_no_location: "деревьев ещё ожидают GPS-координаты",
    shop_filters_title: "Фильтры",
    main_stat_species: "Видов деревьев",

    "map_advanced_filters": "Расширенные фильтры",
    "map_filter_year": "Фильтр по году",
    "map_all_years": "Все годы",
    "map_show_my_trees": "Показать только мои деревья",
    "map_showing": "Показано",
    "map_search_species": "Поиск по видам деревьев",
    "map_search_placeholder": "Введите название дерева...",
    "map_no_species_found": "Виды не найдены",

    // Russian (ru)
    shop_cat_decorative: "Декоративные деревья",
    shop_cat_fruit_trees: "Фруктовые деревья",
    shop_cat_flowers: "Декоративные цветы",
    shop_cat_bushes: "Кустарники",
    shop_events: "Мероприятия",

    // Navbar
    nav_home: "Главная",
    nav_shop: "Магазин",
    nav_map: "Карта",
    nav_community: "Сообщество",
    nav_signin: "Войти",
    nav_register: "Регистрация",
    nav_profile: "Профиль",
    nav_logout: "Выйти",

    // Footer
    foot_about: "О Novda",
    foot_desc: "Делаем посадку деревьев простой, прозрачной и доступной по всему Узбекистану.",
    foot_links: "Быстрые ссылки",
    foot_services: "Услуги",
    foot_contact: "Контакты",
    foot_rights: "Novda. Все права защищены. Делаем мир зеленее, одно дерево за раз.",
    foot_privacy: "Политика конфиденциальности",
    foot_svc_plant: "Посадка деревьев",
    foot_svc_corp: "Корпоративные программы",
    foot_svc_track: "Отследить дерево",
    foot_svc_gift: "Подарить дерево",

    // Auth
    auth_join_title: "Присоединяйся к",
    auth_join_highlight: "Зеленой Революции",
    auth_join_desc: "Получите доступ к экологической панели для отслеживания деревьев и вклада.",
    auth_feat_track_title: "Сажай и отслеживай",
    auth_feat_track_desc: "Мониторинг деревьев с GPS",
    auth_feat_comm_title: "Доступ к сообществу",
    auth_feat_comm_desc: "Общайтесь с единомышленниками",
    auth_feat_impact_title: "Метрики влияния",
    auth_feat_impact_desc: "Статистика поглощения CO₂",
    auth_tab_register: "Регистрация",
    auth_tab_login: "Вход",
    auth_label_fname: "Имя",
    auth_label_lname: "Фамилия",
    auth_label_username: "Имя пользователя",
    auth_label_phone: "Номер телефона",
    auth_label_email: "Email адрес",
    auth_label_dob: "Дата рождения",
    auth_label_region: "Регион",
    auth_label_pass: "Пароль",
    auth_ph_phone: "+998-__-___-__-__",
    auth_select_region: "Выберите регион",
    auth_btn_create: "Создать аккаунт",
    auth_btn_login: "Войти",
    auth_region_qoraqalpaq: "Республика Каракалпакстан",
    auth_region_andijan: "Андижанская область",
    auth_region_bukhara: "Бухарская область",
    auth_region_fergana: "Ферганская область",
    auth_region_jizzakh: "Джизакская область",
    auth_region_khorezm: "Хорезмская область",
    auth_region_namangan: "Наманганская область",
    auth_region_navoiy: "Навоийская область",
    auth_region_kashkadarya: "Кашкадарьинская область",
    auth_region_samarkand: "Самаркандская область",
    auth_region_sirdaryo: "Сырдарьинская область",
    auth_region_surkhandarya: "Сурхандарьинская область",
    auth_region_tashkent_reg: "Ташкентская область",
    auth_region_tashkent_city: "Г. Ташкент",

    // Main Page - Hero
    main_hero_badge: "Сажайте деревья, влияйте на будущее",
    main_hero_title_1: "Сажайте деревья,",
    main_hero_title_2: "Спасайте планету",
    main_hero_desc: "Выберите саженец онлайн — мы посадим его за вас, а вы будете следить за деревом на карте.",
    main_btn_start: "Начать посадку",
    main_btn_watch: "Смотреть видео",
    main_stat_trees: "Деревьев посажено",
    main_stat_members: "Активных участников",
    main_stat_regions: "Регионов",
    main_float_co2_label: "Взрослое дерево в год",
    main_float_co2_val: "≈22 кг CO₂",
    main_float_comm_label: "Каждое дерево",
    main_float_comm_val: "На карте",
    // Main Page - About
    main_about_label: "О NOVDA",
    main_about_title: "Наша миссия",
    main_about_subtitle: "Цифровая экологическая платформа, делающая посадку деревьев простой и прозрачной.",
    main_check_1: "Реальные деревья, посаженные профессионалами",
    main_check_2: "Отслеживание каждого дерева на интерактивной карте",
    main_check_3: "Регулярные обновления о здоровье и росте деревьев",
    main_check_4: "Прозрачное ценообразование без скрытых комиссий",
    main_check_5: "Растущее сообщество любителей природы",
    main_check_6: "Измеримый экологический вклад",

    // Main Page - Why Us
    main_why_label: "ПОЧЕМУ МЫ",
    main_why_title: "Что нас отличает",
    main_why_subtitle: "Узнайте преимущества выбора Novda для вашего вклада в экологию.",
    main_card_real_title: "Реальная посадка",
    main_card_real_desc: "Каждое дерево высаживается экспертами в оптимальных условиях с GPS-координатами.",
    main_card_trans_title: "Полная прозрачность",
    main_card_trans_desc: "Отслеживайте деревья на карте и получайте фотоотчеты роста.",
    main_card_comm_title: "Вклад сообщества",
    main_card_comm_desc: "Присоединяйтесь к участникам по всему Узбекистану, которые меняют экологию к лучшему.",
    main_card_res_title: "Измеримые результаты",
    main_card_res_desc: "Видите реальный вклад с метриками поглощения CO₂.",

    // Main Page - Stats
    main_impact_title: "Наше влияние",
    main_impact_subtitle: "Реальные цифры реальных экологических действий",

    // Main Page - Process
    main_process_label: "КАК ЭТО РАБОТАЕТ",
    main_process_title: "Простые шаги к изменениям",
    main_process_subtitle: "Начните свой экологический путь всего за четыре шага",
    main_step_browse: "Выбрать дерево",
    main_step_browse_desc: "Изучите нашу коллекцию местных деревьев и узнайте об их пользе для климата.",
    main_step_select: "Оформить",
    main_step_select_desc: "Выберите дерево и оплатите заказ за пару кликов с прозрачными ценами.",
    main_step_plant: "Мы сажаем",
    main_step_plant_desc: "Наша команда профессионально высаживает ваше дерево в оптимальных условиях.",
    main_step_track: "Отслеживать",
    main_step_track_desc: "Получайте обновления и наблюдайте за ростом на карте с фотоотчетами.",

    // Shop Page
    shop_hero_badge: "Сажайте деревья, спасайте планету",
    shop_hero_title: "Выберите ваше",
    shop_hero_highlight: "Дерево",
    shop_hero_desc: "Просмотрите нашу подборку местных и адаптивных видов деревьев, идеально подходящих для климата Узбекистана.",
    shop_search_placeholder: "Поиск по названию дерева...",
    shop_filter_cat: "Категория:",
    shop_filter_price: "Цена:",
    shop_sort_label: "Сортировка:",
    shop_cat_all: "Все",
    shop_cat_tree: "Декоративные деревья",
    shop_cat_fruit: "Фруктовые деревья",
    shop_price_all: "Все цены",
    shop_price_under_80: "До 80K",
    shop_price_80_110: "80K - 110K",
    shop_price_over_110: "Более 110K",
    shop_sort_name_asc: "Название (А-Я)",
    shop_sort_name_desc: "Название (Я-А)",
    shop_sort_price_asc: "Цена (Низкая -> Высокая)",
    shop_sort_price_desc: "Цена (Высокая -> Низкая)",
    shop_btn_add: "В корзину",
    shop_btn_added: "✓ В корзине",
    shop_btn_details: "Подробнее",
    shop_empty_title: "Деревья не найдены",
    shop_empty_desc: "Попробуйте изменить фильтры или запрос поиска",
    shop_clear_filters: "Сбросить фильтры",
    shop_loading: "Загрузка товаров...",
    shop_error: "Не удалось загрузить товары.",
    shop_found: "деревьев найдено",

    // Product Detail
    // Product Detail
    prod_not_found: "Товар не найден",
    prod_back: "Назад в магазин",
    prod_add_cart: "Добавить в корзину",
    prod_desc_fallback: "Описание отсутствует.",
    prod_loading: "Загрузка товара...",
    prod_not_found_desc: "Дерево, которое вы ищете, не существует",
    prod_price: "Цена",
    prod_qty: "Количество",
    check_trees_qty: "Количество деревьев",

    // Payment Page
    pay_title: "Оплата",
    pay_subtitle: "Выберите способ оплаты для завершения заказа",
    pay_order_summary: "Сводка заказа",
    pay_subtotal: "Подитог",
    pay_discount: "Скидка",
    pay_total_amount: "Итого",
    pay_back: "Назад",
    pay_processing: "Обработка...",
    pay_complete: "Завершить заказ",
    pay_your_order: "Ваш заказ",
    pay_total_trees: "Всего деревьев",
    pay_total: "Итого",
    pay_secure: "Безопасная оплата",
    pay_ssl: "SSL шифрование",
    pay_loading: "Загрузка...",
    prod_info_delivery: "Бесплатная доставка",
    prod_info_delivery_desc: "При заказе от 500,000 UZS",
    prod_info_quality: "Гарантия качества",
    prod_info_quality_desc: "100% здоровые растения",
    prod_info_support: "Поддержка 24/7",
    prod_info_support_desc: "Экспертные советы по садоводству",

    // Cart
    cart_title: "Корзина",
    cart_empty_title: "Ваша корзина пуста",
    cart_empty_text: "Начните сажать деревья ради зеленого будущего!",
    cart_btn_browse: "Выбрать деревья",
    cart_banner_text: "Вы можете изменить размер и количество для каждого дерева ниже",
    cart_shipping: "Бесплатная услуга посадки для всех заказов!",
    cart_customize: "Настроить дерево",

    cart_qty: "Кол-во",
    cart_item_total: "Итого:",
    cart_continue: "Продолжить покупки",
    cart_summary_title: "Сводка заказа",
    cart_subtotal: "Подытог",
    cart_discount: "Специальная скидка: ",
    cart_service: "Услуга посадки",
    cart_free: "БЕСПЛАТНО",
    cart_total: "Итого",
    cart_checkout: "Перейти к оформлению",
    cart_secure: "Безопасная оплата · SSL шифрование",
    cart_item_single: "товар",
    cart_item_plural: "товаров",
    cart_you_save: "Вы экономите",
    cart_info_planting: "Бесплатная посадка",
    cart_info_planting_desc: "Мы профессионально посадим ваше дерево",
    cart_info_quality: "Гарантия качества",
    cart_info_quality_desc: "100% здоровые деревья или замена",
    cart_info_support: "Поддержка 24/7",
    cart_info_support_desc: "Мы всегда готовы помочь",

    // Checkout
    check_title: "Оформление заказа",
    check_desc: "Завершите заказ на посадку деревьев",
    check_info_title: "Информация о посадке",
    check_label_name: "ФИО",
    check_ph_name: "Введите ваше полное имя",
    check_note_cert: "Для вашего цифрового сертификата",
    check_label_phone: "Номер телефона",
    check_label_region: "Регион посадки",
    check_select_region: "Выберите регион",
    check_dedication_title: "Посвящения",
    check_dedication_desc: "Каждое дерево появится на интерактивной карте. Добавьте личное сообщение для каждого.",
    check_mode_same: "Одно посвящение для всех",
    check_mode_indiv: "Индивидуальные посвящения",
    check_msg_label: "Сообщение (необязательно)",
    check_msg_ph: "В память о... / Для моей семьи...",
    check_payment_title: "Способ оплаты",
    check_btn_pay: "Оплатить заказ",
    check_processing: "Обработка...",
    check_err_name: "Введите полное имя",
    check_err_phone: "Введите номер телефона",
    check_err_region: "Выберите регион",
    check_err_payment: "Выберите способ оплаты",
    check_tree_num: "Дерево",
    check_title_review: "Обзор заказа",
    check_subtitle_review: "Пожалуйста, проверьте детали заказа перед оплатой",
    check_items_title: "Товары в заказе",

    check_item_qty: "Кол-во",
    check_off: "Скидка",
    check_btn_back_cart: "Назад в корзину",
    check_btn_continue: "Перейти к оплате",
    check_secure: "Безопасная оплата",
    check_ssl: "SSL шифрование",
    check_info_note: "Для обновления информации, посетите страницу профиля",
    check_total_trees: "Всего деревьев",

    // Order Confirmation
    order_confirmed: "Заказ подтвержден!",
    order_thank_you: "Спасибо за вклад в зеленое будущее",
    order_id: "ID заказа",
    order_date: "Дата",
    order_impact_text: "Экологический вклад: Ваш заказ поможет поглотить примерно",
    order_btn_home: "На главную",

    // Profile
    prof_edit: "Изменить",
    prof_trees: "Деревья",
    prof_badges: "Значки",
    prof_interests: "Интересы:",
    prof_location: "Локация",
    prof_email: "Email",
    prof_phone: "Телефон",
    prof_joined: "Вступил",
    prof_my_trees: "Мои деревья",
    prof_view_map: "Показать на карте",
    prof_share: "Поделиться",
    prof_recent_activity: "Недавняя активность",
    prof_impact: "Экологический вклад",
    prof_roadmap: "Карта достижений",
    prof_progress: "Ваш прогресс",
    prof_badge_eco: "Эко-воин",
    prof_badge_gold: "Золотой участник",
    prof_badge_ver: "Подтвержден",
    prof_co2_seq: "Всего CO₂ поглощено",
    prof_oxy_prod: "Кислорода выработано (Оценка)",
    prof_wild_hab: "Среда обитания создана",
    prof_land_green: "Озелененная территория",
    prof_modal_title: "Редактировать профиль",
    prof_label_name: "ФИО",
    prof_label_bio: "О себе",
    prof_label_phone: "Номер телефона",
    prof_label_region: "Регион",
    prof_label_email: "Email",
    prof_btn_save: "Сохранить",
    prof_btn_cancel: "Отмена",
    prof_btn_saving: "Сохранение...",
    prof_planted_on: "Посажено",

    // Orders
    orders_title: "Мои заказы",
    orders_subtitle: "Отслеживайте заказы деревьев и процесс посадки",
    orders_loading: "Загрузка заказов...",
    orders_total: "Всего заказов",
    orders_trees_ordered: "Деревьев заказано",
    orders_active: "Активные",
    orders_completed: "Выполненные",
    orders_filter_all: "Все заказы",
    orders_filter_active: "Активные",
    orders_filter_completed: "Выполненные",
    orders_empty_title: "Заказов пока нет",
    orders_empty_filter: "Нет заказов по этому фильтру",
    orders_empty_desc: "Посетите магазин, чтобы заказать первые деревья!",
    orders_go_shop: "В магазин",
    orders_order_id: "Заказ",
    orders_quantity: "Кол-во",

    orders_status_ordered: "Заказано",
    orders_status_processing: "В обработке",
    orders_status_planted: "Посажено",
    orders_step_ordered: "Заказано",
    orders_step_processing: "Обработка",
    orders_step_planted: "Посажено",

    // Map
    map_filter_all: "Все",
    map_welcome_title: "Карта Novda",
    map_welcome_desc: "Добро пожаловать в цифровой лес. Эта платформа отслеживает реальные деревья.",
    map_guide_explore: "Как исследовать",
    map_stat_mapped: "Деревьев на карте",
    map_stat_co2: "кг CO₂ удалено",
    map_adopt_btn: "Усыновить похожее дерево",
    map_swipe: "Свайп для фото",
    map_urban_contrib: "Вклад в городскую среду",
    map_health_well: "Здоровье и благополучие",
    map_total_co2: "Всего CO₂ удалено",
    map_tree_age: "Возраст дерева",
    map_owner: "Владелец",
    map_region: "Регион",
    map_superpower: "Суперсила",
    map_impact_title: "Влияние проекта",
    map_active_zones: "Активные зоны",
    map_survival_rate: "Выживаемость",

    // Community
    comm_hero_title: "Наше растущее",
    comm_hero_highlight: "Сообщество",
    comm_hero_desc: "Присоединяйтесь к волонтерам и любителям природы, которые делают Узбекистан зеленее.",
    comm_btn_join: "Вступить в сообщество",
    comm_btn_leaderboard: "Смотреть таблицу лидеров",
    comm_champions: "Чемпионы сообщества",
    comm_subtitle_champions: "Познакомьтесь с самыми активными участниками, меняющими мир сегодня",
    comm_leaderboard_title: "Лучшие участники",
    comm_subtitle_leaderboard: "Участники по количеству посаженных для них деревьев",
    comm_voices: "Голоса сообщества",
    comm_subtitle_voices: "Что наши волонтеры говорят о своем пути",
    comm_rank: "Ранг",
    comm_user: "Пользователь",
    comm_region: "Регион",
    comm_trees_planted: "Деревьев",
    comm_impact_co2: "Вклад (CO₂)",
    comm_planting_journey: "Наш путь посадки",
    comm_subtitle_journey: "Моменты с наших волонтерских мероприятий",

    // Community - Roles
    comm_role_eco_warrior: "Эко-воин",
    comm_role_community_lead: "Лидер сообщества",
    comm_role_volunteer: "Волонтёр",
    comm_role_ambassador: "Амбассадор",

    // Community - Stat labels
    comm_stat_trees: "Деревья",
    comm_stat_events: "События",

    // Community - Testimonials
    comm_quote_1: "Посадка моего первого дерева с Novda была эмоциональным моментом. Знать, что я могу следить за его ростом, делает это ещё более особенным. Это не просто пожертвование — это наследие.",
    comm_quote_2: "Мероприятия сообщества потрясающие. Я встретил столько людей-единомышленников, которым не безразлична наша окружающая среда. Прозрачность этой платформы не имеет себе равных.",
    comm_quote_3: "Я подарил деревья своим сотрудникам на Новый год. Им понравилась идея иметь свои деревья на карте. Лучший корпоративный подарок!",
    comm_quote_4: "Невероятно видеть, сколько людей присоединяются к этому движению. Функция карты затягивает — я проверяю каждый день, чтобы увидеть новые деревья!",
    comm_author_role_business: "Предприниматель",
    comm_author_role_student: "Студент",

    filter_all: "Все",
    filter_fruit: "Фруктовые деревья",
    filter_evergreen: "Вечнозеленые",
    filter_shade: "Тенистые",
    filter_decorative: "Декоративные деревья",
    filter_tree: "Деревья",

    // Additional Map Keys (RU)
    map_cat_all: "Все деревья",
    map_cat_fruit: "Фруктовые деревья",
    map_cat_decorative: "Декоративные деревья",
    map_cat_flowers: "Цветы",
    map_cat_bushes: "Кустарники",
    map_filter_btn: "Фильтры",
    map_year_label: "Год",
    map_year_all: "Все годы",
    map_search_label: "Поиск дерева",
    map_search_ph: "Введите название...",
    map_my_trees: "Показать только мои",
    map_showing: "Показано",
    map_clear: "Очистить все",
    map_welcome_explore: "Как исследовать",
    map_step_filter: "Используйте фильтры для поиска",
    map_step_click: "Нажимайте на маркеры для деталей",
    map_step_photos: "Смотрите фото посаженных деревьев",
    map_impact_header: "Влияние",
    map_stat_trees_short: "Деревья",
    map_stat_co2_short: "кг CO₂",
    map_stat_regions: "Регионы",
    map_stat_years_active: "Годы активности",
    main_stat_co2: "CO₂ поглощено",
    map_swipe_short: "Листать",
    map_desc_title: "Описание",
    map_health_title: "Польза для здоровья",
    map_meta_co2: "Поглощение CO₂",
    map_meta_age: "Возраст",
    map_meta_owner: "Владелец",
    map_meta_planted_by: "Посадил",
    map_meta_planted_on: "Дата посадки",
    map_benefit_air: "Чистый воздух",
    map_benefit_shade: "Тень",
    map_benefit_mental: "Психическое здоровье",
  },

  uz: {
    comm_cta_desc: "Bugun birinchi daraxtingizni eking va reytingga kiring.",
    comm_cta_title: "Sizning ismingiz ham shu ro'yxatda bo'lishi mumkin",
    comm_loading: "Jamiyat yuklanmoqda…",
    comm_empty: "Hali birorta daraxt ekilmagan. Birinchi bo'ling!",
    comm_planted_for: "Kim uchun",
    comm_no_location: "Joylashuv tez orada",
    comm_view_map: "Xaritada ko'rish",
    comm_recent_sub: "Jamoamiz a'zolar uchun ekkan so'nggi daraxtlar",
    comm_recent_title: "Yaqinda ekilganlar",
    comm_stat_regions: "Hududlar",
    comm_stat_planted: "Ekilgan daraxtlar",
    comm_stat_members: "A'zolar",
    home_price_from: "dan",
    home_feat_all: "Barcha daraxtlar",
    home_feat_title: "Shulardan birini tanlang",
    home_feat_label: "Mashhur daraxtlar",
    home_how_3_d: "Daraxtingizni jonli xaritada va profilingizda ko'ring.",
    home_how_3_t: "Kuzatib boring",
    home_how_2_d: "Jamoamiz daraxtingizni siz uchun ekadi. Belkurak kerak emas.",
    home_how_2_t: "Biz ekamiz",
    home_how_1_d: "Do'konimizda {n} ta mahalliy daraxt turi bor. Narxlar {price} so'mdan.",
    home_how_1_t: "Ko'chat tanlang",
    home_how_title: "Uch qadamda o'z daraxtingiz",
    home_how_label: "Qanday ishlaydi",
    auth_step_account: "Hisob",
    auth_step_contact: "Aloqa ma'lumotlari",
    auth_btn_next: "Davom etish",
    auth_btn_back: "Orqaga",
    auth_ok_registered: "Hisobingiz tayyor! Davom etish uchun kiring.",
    auth_err_session: "Kirish bajarildi, lekin brauzer kirish cookie faylini blokladi. Qaytadan urinib ko'ring yoki boshqa brauzerdan foydalaning.",
    comm_btn_plant: "Daraxt ekish",
    auth_err_network: "Server bilan aloqa yo'q. Internetni tekshirib, qaytadan urinib ko'ring.",
    auth_err_register: "Ro'yxatdan o'tib bo'lmadi. Ma'lumotlarni tekshirib, qaytadan urinib ko'ring.",
    auth_err_login: "Foydalanuvchi nomi yoki parol noto'g'ri. Qaytadan urinib ko'ring.",
    map_trees_no_location: "ta daraxt hali GPS joylashuvini kutmoqda",
    shop_filters_title: "Filtrlar",
    main_stat_species: "Daraxt turlari",

    "map_advanced_filters": "Kengaytirilgan filtrlar",
    "map_filter_year": "Yil bo'yicha filtrlash",
    "map_all_years": "Barcha yillar",
    "map_show_my_trees": "Faqat mening daraxtlarimni ko'rsatish",
    "map_showing": "Ko'rsatilmoqda",
    "map_search_species": "Daraxt turini qidirish",
    "map_search_placeholder": "Daraxt nomini kiriting...",
    "map_no_species_found": "Turlar topilmadi",

    // Uzbek (uz)
    shop_cat_decorative: "Manzarali daraxtlar",
    shop_cat_fruit_trees: "Mevali daraxtlar",
    shop_cat_flowers: "Manzarali gullar",
    shop_cat_bushes: "Butalar",
    shop_events: "Tadbirlar",

    nav_home: "Bosh Sahifa",
    nav_shop: "Do'kon",
    nav_map: "Xarita",
    nav_community: "Jamiyat",
    nav_signin: "Kirish",
    nav_register: "Ro'yxatdan o'tish",
    nav_profile: "Profil",
    nav_logout: "Chiqish",

    foot_about: "Novda Haqida",
    foot_desc: "Daraxt ekishni O'zbekiston bo'ylab oddiy, shaffof va ommaviy qilish.",
    foot_links: "Tezkor havolalar",
    foot_services: "Xizmatlar",
    foot_contact: "Bog'lanish",
    foot_rights: "Novda. Barcha huquqlar himoyalangan. Bir vaqtning o'zida bitta daraxt bilan dunyoni yashil qilish.",
    foot_privacy: "Maxfiylik siyosati",
    foot_svc_plant: "Daraxt ekish",
    foot_svc_corp: "Korporativ dasturlar",
    foot_svc_track: "Daraxtni kuzatish",
    foot_svc_gift: "Daraxt sovg'a qilish",

    auth_join_title: "Yashil Inqilobga",
    auth_join_highlight: "Qo'shiling",
    auth_join_desc: "Daraxtlaringizni kuzatish, jamoa ta'sirini ko'rish va hissalaringizni boshqarish uchun ekologik panelga kiring.",
    auth_feat_track_title: "Eking va Kuzating",
    auth_feat_track_desc: "GPS kuzatuvi bilan daraxtlaringizni monitoring qiling",
    auth_feat_comm_title: "Jamiyatga kirish",
    auth_feat_comm_desc: "Hamfikrlar bilan bog'laning",
    auth_feat_impact_title: "Ta'sir ko'rsatkichlari",
    auth_feat_impact_desc: "Real vaqtda CO₂ yutilish statistikasi",
    auth_tab_register: "Ro'yxatdan o'tish",
    auth_tab_login: "Kirish",
    auth_label_fname: "Ism",
    auth_label_lname: "Familiya",
    auth_label_username: "Foydalanuvchi nomi",
    auth_label_phone: "Telefon raqam",
    auth_label_email: "Email manzil",
    auth_label_dob: "Tug'ilgan sana",
    auth_label_region: "Hudud",
    auth_label_pass: "Parol",
    auth_ph_phone: "+998-__-___-__-__",
    auth_select_region: "Hududni tanlang",
    auth_btn_create: "Hisob yaratish",
    auth_btn_login: "Kirish",
    auth_region_qoraqalpaq: "Qoraqalpogʻiston Respublikasi",
    auth_region_andijan: "Andijon viloyati",
    auth_region_bukhara: "Buxoro viloyati",
    auth_region_fergana: "Fargʻona viloyati",
    auth_region_jizzakh: "Jizzax viloyati",
    auth_region_khorezm: "Xorazm viloyati",
    auth_region_namangan: "Namangan viloyati",
    auth_region_navoiy: "Navoiy viloyati",
    auth_region_kashkadarya: "Qashqadaryo viloyati",
    auth_region_samarkand: "Samarqand viloyati",
    auth_region_sirdaryo: "Sirdaryo viloyati",
    auth_region_surkhandarya: "Surxondaryo viloyati",
    auth_region_tashkent_reg: "Toshkent viloyati",
    auth_region_tashkent_city: "Toshkent shahri",

    main_hero_badge: "Daraxt eking, o'zgarish qiling",
    main_hero_title_1: "Daraxt eking,",
    main_hero_title_2: "Sayyoramizni asrang",
    main_hero_desc: "Ko'chatni onlayn tanlang — jamoamiz uni siz uchun ekadi, siz esa daraxtingizni xaritada kuzatasiz.",
    main_btn_start: "Ekishni boshlash",
    main_btn_watch: "Videoni ko'rish",
    main_stat_trees: "Ekilgan daraxtlar",
    main_stat_members: "Faol a'zolar",
    main_stat_regions: "Viloyatlar",
    main_float_co2_label: "Katta daraxt yiliga",
    main_float_co2_val: "≈22 kg CO₂",
    main_float_comm_label: "Har bir daraxt",
    main_float_comm_val: "Xaritada",
    main_about_label: "NOVDA HAQIDA",
    main_about_title: "Bizning vazifamiz",
    main_about_subtitle: "Daraxt ekishni oddiy, shaffof va ommaviy qiladigan raqamli ekologik platforma.",
    main_check_1: "Mutaxassislar tomonidan ekiladigan haqiqiy daraxtlar",
    main_check_2: "Har bir daraxtni interaktiv xaritada kuzating",
    main_check_3: "Daraxt o'sishi haqida muntazam yangiliklar oling",
    main_check_4: "Yashirin to'lovlarsiz shaffof narxlar",
    main_check_5: "O'sib borayotgan tabiat ixlosmandlari jamiyatiga qo'shiling",
    main_check_6: "Atrof-muhitga sezilarli ta'sir ko'rsating",
    main_why_label: "NEGA BIZ",
    main_why_title: "Bizning ustunligimiz",
    main_why_subtitle: "Atrof-muhitga ta'sir o'tkazish uchun nima uchun Novda ni tanlash kerakligini bilib oling.",
    main_card_real_title: "Haqiqiy ekish",
    main_card_real_desc: "Har bir daraxt mutaxassislar tomonidan GPS koordinatalari bilan ekiladi.",
    main_card_trans_title: "To'liq shaffoflik",
    main_card_trans_desc: "Xaritada daraxtlaringizni kuzating va o'sish rasmlarini oling.",
    main_card_comm_title: "Jamoa ta'siri",
    main_card_comm_desc: "O'zbekiston bo'ylab real ekologik o'zgarish qilayotgan a'zolarga qo'shiling.",
    main_card_res_title: "O'lchanadigan natijalar",
    main_card_res_desc: "CO₂ yutilish ko'rsatkichlari bilan aniq ta'siringizni ko'ring.",
    main_impact_title: "Bizning natijalar",
    main_impact_subtitle: "Haqiqiy ekologik harakatlardan olingan real raqamlar",
    main_process_label: "ISHLAŞ TARTIBI",
    main_process_title: "O'zgarish qilish uchun oddiy qadamlar",
    main_process_subtitle: "Ekologik sayohatni atigi to'rt oson qadamda boshlang",
    main_step_browse: "Daraxt tanlash",
    main_step_browse_desc: "Bizning mahalliy daraxtlar to'plamimizni ko'rib chiqing va ularning foydalarini o'rganing.",
    main_step_select: "Tanlash va Sotib olish",
    main_step_select_desc: "Daraxtni tanlang va bir necha bosishda xavfsiz to'lovni amalga oshiring.",
    main_step_plant: "Biz Ekamiz",
    main_step_plant_desc: "Bizning jamoamiz daraxtingizni optimal sharoitda professional tarzda ekadi.",
    main_step_track: "Kuzatish va Monitoring",
    main_step_track_desc: "Doimiy yangiliklarni oling va xaritada daraxtingiz o'sishini kuzatib boring.",

    shop_hero_badge: "Daraxt eking, Sayyorani asrang",
    shop_hero_title: "O'z daraxtingizni",
    shop_hero_highlight: "Tanlang",
    shop_hero_desc: "O'zbekiston iqlimiga moslashtirilgan mahalliy daraxt turlari to'plamini ko'rib chiqing.",
    shop_search_placeholder: "Daraxt nomi bo'yicha qidirish...",
    shop_filter_cat: "Kategoriya:",
    shop_filter_price: "Narx:",
    shop_sort_label: "Saralash:",
    shop_cat_all: "Barchasi",
    shop_cat_tree: "Manzarali daraxtlar",
    shop_cat_fruit: "Meva daraxtlar",
    shop_price_all: "Barcha narxlar",
    shop_price_under_80: "80K dan arzon",
    shop_price_80_110: "80K - 110K",
    shop_price_over_110: "110K dan qimmat",
    shop_sort_name_asc: "Nom (A-Z)",
    shop_sort_name_desc: "Nom (Z-A)",
    shop_sort_price_asc: "Narx (Arzon -> Qimmat)",
    shop_sort_price_desc: "Narx (Qimmat -> Arzon)",
    shop_btn_add: "Savatga qo'shish",
    shop_btn_added: "✓ Qo'shildi",
    shop_btn_details: "Batafsil",
    shop_empty_title: "Daraxtlar topilmadi",
    shop_empty_desc: "Filtrlarni yoki qidiruv so'zini o'zgartirib ko'ring",
    shop_clear_filters: "Filtrlarni tozalash",
    shop_loading: "Daraxtlar yuklanmoqda...",
    shop_error: "Yuklashda xatolik.",
    shop_found: "ta daraxt topildi",

    // Product Detail
    prod_not_found: "Mahsulot topilmadi",
    prod_back: "Do'konga qaytish",
    prod_add_cart: "Savatga qo'shish",
    prod_desc_fallback: "Tavsif mavjud emas.",
    prod_loading: "Mahsulot yuklanmoqda...",
    prod_not_found_desc: "Siz qidirayotgan daraxt mavjud emas",
    prod_price: "Narx",
    prod_qty: "Miqdor",
    prod_info_delivery: "Bepul yetkazib berish",
    prod_info_delivery_desc: "500,000 UZS dan ortiq buyurtmalarga",
    prod_info_quality: "Sifat kafolati",
    prod_info_quality_desc: "100% sog'lom o'simliklar",
    prod_info_support: "24/7 Qo'llab-quvvatlash",
    prod_info_support_desc: "Bog'dorchilik bo'yicha maslahat",

    cart_title: "Savat",
    cart_empty_title: "Savatingiz bo'sh",
    cart_empty_text: "Yashil kelajak uchun daraxt ekishni boshlang!",
    cart_btn_browse: "Daraxtlarni ko'rish",
    cart_banner_text: "Quyida har bir daraxtning o'lchami va miqdorini o'zgartirishingiz mumkin",
    cart_shipping: "Barcha buyurtmalar uchun bepul ekish xizmati!",
    cart_customize: "Daraxtni sozlash",

    cart_qty: "Miqdor",
    cart_item_total: "Jami:",
    cart_continue: "Xaridni davom ettirish",
    cart_summary_title: "Buyurtma haqida",
    cart_subtotal: "Oraliq jami",
    cart_discount: "Maxsus chegirma: ",
    cart_service: "Ekish xizmati",
    cart_free: "BEPUL",
    cart_total: "Jami",
    cart_checkout: "Rasmiylashtirish",
    cart_secure: "Xavfsiz to'lov · SSL shifrlangan",
    cart_item_single: "mahsulot",
    cart_item_plural: "mahsulotlar",
    cart_you_save: "Siz tejaysiz",
    cart_info_planting: "Bepul ekish xizmati",
    cart_info_planting_desc: "Daraxtingizni professional tarzda ekamiz",
    cart_info_quality: "Sifat kafolati",
    cart_info_quality_desc: "100% sog'lom daraxtlar yoki almashtirish",
    cart_info_support: "24/7 Qo'llab-quvvatlash",
    cart_info_support_desc: "Sizga yordam berishga tayyormiz",

    // Checkout
    check_title: "Rasmiylashtirish",
    check_desc: "Daraxt ekish buyurtmasini yakunlang",
    check_info_title: "Ekish ma'lumotlari",
    check_label_name: "F.I.SH",
    check_ph_name: "To'liq ismingizni kiriting",
    check_note_cert: "Raqamli sertifikatingiz uchun",
    check_label_phone: "Telefon raqami",
    check_label_region: "Ekish hududi",
    check_select_region: "Hududni tanlang",
    check_dedication_title: "Daraxtga tilaklar",
    check_dedication_desc: "Har bir daraxt interaktiv xaritada paydo bo'ladi. Har biri uchun shaxsiy xabar qo'shing.",
    check_mode_same: "Barcha daraxtlar uchun bitta tilak",
    check_mode_indiv: "Har biri uchun alohida",
    check_msg_label: "Tilak xabari (Ixtiyoriy)",
    check_msg_ph: "Xotira uchun... / Oilam uchun...",
    check_payment_title: "To'lov turi",
    check_btn_pay: "Buyurtmani yakunlash",
    check_processing: "Qayta ishlanmoqda...",
    check_err_name: "To'liq ism kiritilishi shart",
    check_err_phone: "Telefon raqam kiritilishi shart",
    check_err_region: "Hududni tanlang",
    check_err_payment: "To'lov turini tanlang",
    check_tree_num: "Daraxt",
    check_trees_qty: "Daraxtlar soni",
    check_title_review: "Buyurtmani tekshirish",
    check_subtitle_review: "To'lovga o'tishdan oldin buyurtma tafsilotlarini tekshiring",
    check_items_title: "Buyurtma mahsulotlari",

    check_item_qty: "Miqdori",
    check_off: "Chegirma",
    check_btn_back_cart: "Savatga qaytish",
    check_btn_continue: "To'lovga o'tish",
    check_secure: "Xavfsiz to'lov",
    check_ssl: "SSL shifrlangan",
    check_info_note: "Ma'lumotlaringizni yangilash uchun profil sahifasiga o'ting",
    check_total_trees: "Jami daraxtlar",

    // Payment Page
    pay_title: "To'lov",
    pay_subtitle: "Buyurtmani yakunlash uchun to'lov usulini tanlang",
    pay_order_summary: "Buyurtma xulosasi",
    pay_subtotal: "Oraliq jami",
    pay_discount: "Chegirma",
    pay_total_amount: "Jami summa",
    pay_back: "Orqaga",
    pay_processing: "Jarayonda...",
    pay_complete: "Buyurtmani yakunlash",
    pay_your_order: "Sizning buyurtmangiz",
    pay_total_trees: "Jami daraxtlar",
    pay_total: "Jami",
    pay_secure: "Xavfsiz to'lov",
    pay_ssl: "SSL shifrlangan",
    pay_loading: "Yuklanmoqda...",

    order_confirmed: "Buyurtma tasdiqlandi!",
    order_thank_you: "Yashil kelajakga hissa qo'shganingiz uchun rahmat",
    order_id: "Buyurtma ID",
    order_date: "Sana",
    order_impact_text: "Ekologik ta'sir: Sizning buyurtmangiz yillik taxminan shuncha CO₂ yutadi:",
    order_btn_home: "Bosh sahifaga",

    prof_edit: "Tahrirlash",
    prof_trees: "Daraxtlar",
    prof_badges: "Nishonlar",
    prof_interests: "Qiziqishlar:",
    prof_location: "Manzil",
    prof_email: "Email",
    prof_phone: "Tel",
    prof_joined: "Qo'shildi",
    prof_my_trees: "Mening daraxtlarim",
    prof_view_map: "Xaritada ko'rish",
    prof_share: "Ulashish",
    prof_recent_activity: "So'nggi faollik",
    prof_impact: "Ekologik ta'sir",
    prof_roadmap: "Yutuqlar xaritasi",
    prof_progress: "Sizning natijangiz",
    prof_badge_eco: "Ekologik jangchi",
    prof_badge_gold: "Oltin a'zo",
    prof_badge_ver: "Tasdiqlangan",
    prof_co2_seq: "Jami yutilgan CO₂",
    prof_oxy_prod: "Ishlab chiqarilgan kislorod",
    prof_wild_hab: "Yaratilgan yashash muhiti",
    prof_land_green: "Ko'kalamzorlashtirilgan maydon",
    prof_modal_title: "Profilni tahrirlash",
    prof_label_name: "To'liq ism",
    prof_label_bio: "O'zingiz haqida",
    prof_label_phone: "Telefon raqam",
    prof_label_region: "Hudud",
    prof_label_email: "Email",
    prof_btn_save: "Saqlash",
    prof_btn_cancel: "Bekor qilish",
    prof_btn_saving: "Saqlanmoqda...",
    prof_planted_on: "Ekilgan sana",

    // Orders
    orders_title: "Mening buyurtmalarim",
    orders_subtitle: "Daraxt buyurtmalaringiz va ekish jarayonini kuzating",
    orders_loading: "Buyurtmalar yuklanmoqda...",
    orders_total: "Jami buyurtmalar",
    orders_trees_ordered: "Buyurtma qilingan daraxtlar",
    orders_active: "Faol",
    orders_completed: "Bajarilgan",
    orders_filter_all: "Barcha buyurtmalar",
    orders_filter_active: "Faol",
    orders_filter_completed: "Bajarilgan",
    orders_empty_title: "Hali buyurtma yo'q",
    orders_empty_filter: "Bu filtrga mos buyurtma yo'q",
    orders_empty_desc: "Birinchi daraxtlaringizni buyurtma qilish uchun do'konga tashrif buyuring!",
    orders_go_shop: "Do'konga o'tish",
    orders_order_id: "Buyurtma",
    orders_quantity: "Soni",

    orders_status_ordered: "Buyurtma qilingan",
    orders_status_processing: "Jarayonda",
    orders_status_planted: "Ekilgan",
    orders_step_ordered: "Buyurtma qilingan",
    orders_step_processing: "Jarayonda",
    orders_step_planted: "Ekilgan",

    map_filter_all: "Barchasi",
    map_welcome_title: "Novda Xaritasi",
    map_welcome_desc: "Raqamli o'rmonga xush kelibsiz. Bu platforma ekotizimni yaxshilash uchun ekilgan daraxtlarni kuzatadi.",
    map_guide_explore: "Qanday foydalaniladi",
    map_stat_mapped: "Xaritadagi daraxtlar",
    map_stat_co2: "kg CO₂ tozalandi",
    map_adopt_btn: "Shunga o'xshash daraxt ekish",
    map_swipe: "Rasmlarni ko'rish",
    map_urban_contrib: "Shahar muhitiga hissasi",
    map_health_well: "Salomatlik va farovonlik",
    map_total_co2: "Jami CO₂ tozalandi",
    map_tree_age: "Daraxt yoshi",
    map_owner: "Egasi",
    map_region: "Hudud",
    map_superpower: "Shahar uchun foydasi",
    map_impact_title: "Loyiha ta'siri",
    map_active_zones: "Faol zonalar",
    map_survival_rate: "Yashovchanlik darajasi",

    comm_hero_title: "Bizning o'sib borayotgan",
    comm_hero_highlight: "Jamiyatimiz",
    comm_hero_desc: "O'zbekistonni yashilroq qilish uchun birlashgan ko'ngillilar va tabiat ixlosmandlariga qo'shiling.",
    comm_btn_join: "Jamiyatga qo'shilish",
    comm_btn_leaderboard: "Reytingni ko'rish",
    comm_champions: "Jamiyat qahramonlari",
    comm_subtitle_champions: "Bugungi kunda o'zgarish qilayotgan eng faol a'zolar bilan tanishing",
    comm_leaderboard_title: "Eng faol a'zolar",
    comm_subtitle_leaderboard: "A'zolar ular uchun ekilgan daraxtlar soni bo'yicha",
    comm_voices: "Jamiyat fikrlari",
    comm_subtitle_voices: "Bizning ko'ngillilarimiz nima deydi",
    comm_rank: "O'rin",
    comm_user: "Foydalanuvchi",
    comm_region: "Hudud",
    comm_trees_planted: "Ekilgan daraxtlar",
    comm_impact_co2: "Ta'sir (CO₂)",
    comm_planting_journey: "Bizning ekish sayohatimiz",
    comm_subtitle_journey: "Volontyorlik tadbirlarimiz va jamoaviy ishlarimizdan lahzalar",

    // Community - Roles
    comm_role_eco_warrior: "Eko jangchi",
    comm_role_community_lead: "Jamoa rahbari",
    comm_role_volunteer: "Ko'ngilli",
    comm_role_ambassador: "Elchi",

    // Community - Stat labels
    comm_stat_trees: "Daraxtlar",
    comm_stat_events: "Tadbirlar",

    // Community - Testimonials
    comm_quote_1: "Novda bilan birinchi daraxtimni ekish juda hayajonli bo'ldi. Uning o'sishini kuzatish mumkinligini bilish buni yanada alohida qiladi. Bu shunchaki xayriya emas — bu meros.",
    comm_quote_2: "Jamoa tadbirlari ajoyib. Men atrof-muhitga befarq bo'lmagan ko'plab hamfikrlarni uchratdim. Bu platformaning shaffofligi tengsiz.",
    comm_quote_3: "Men xodimlarimga Yangi yilga daraxtlar sovg'a qildim. Ularga xaritada o'z daraxtlariga ega bo'lish g'oyasi yoqdi. Eng yaxshi korporativ sovg'a!",
    comm_quote_4: "Bu harakatga qancha odam qo'shilayotganini ko'rish ajoyib. Xarita funksiyasi juda qiziqarli — men har kuni yangi daraxtlarni ko'rish uchun tekshiraman!",
    comm_author_role_business: "Tadbirkor",
    comm_author_role_student: "Talaba",

    filter_all: "Barchasi",
    filter_fruit: "Meva daraxtlar",
    filter_evergreen: "Doimiy yashil",
    filter_shade: "Soya beruvchi",
    filter_decorative: "Manzarali daraxtlar",
    filter_tree: "Daraxtlar",

    // Additional Map Keys (UZ)
    map_cat_all: "Barcha daraxtlar",
    map_cat_fruit: "Mevali daraxtlar",
    map_cat_decorative: "Manzarali daraxtlar",
    map_cat_flowers: "Gullar",
    map_cat_bushes: "Butalar",
    map_filter_btn: "Filtrlar",
    map_year_label: "Yil",
    map_year_all: "Barcha yillar",
    map_search_label: "Daraxt qidirish",
    map_search_ph: "Nomini kiriting...",
    map_my_trees: "Faqat mening daraxtlarim",
    map_showing: "Ko'rsatilmoqda",
    map_clear: "Tozalash",
    map_welcome_explore: "Qanday foydalaniladi",
    map_step_filter: "Qidirish uchun filtrlardan foydalaning",
    map_step_click: "Ma'lumot uchun belgilarni bosing",
    map_step_photos: "Ekilgan daraxtlarning rasmlarini ko'ring",
    map_impact_header: "Ta'sir",
    map_stat_trees_short: "Daraxtlar",
    map_stat_co2_short: "kg CO₂",
    map_stat_regions: "Hududlar",
    map_stat_years_active: "Faol yillar",
    main_stat_co2: "CO₂ yutilgan",
    map_swipe_short: "Surish",
    map_desc_title: "Tavsif",
    map_health_title: "Salomatlik uchun foydasi",
    map_meta_co2: "CO₂ yutilishi",
    map_meta_age: "Yoshi",
    map_meta_owner: "Egasi",
    map_meta_planted_by: "Ekuvchi",
    map_meta_planted_on: "Ekilgan sana",
    map_benefit_air: "Toza havo",
    map_benefit_shade: "Soya",
    map_benefit_mental: "Ruhiy salomatlik",
  }
};